import * as Sentry from '@sentry/react';

const dsn = process.env.REACT_APP_SENTRY_DSN || '';
const environment = process.env.REACT_APP_SENTRY_ENVIRONMENT || process.env.NODE_ENV || 'development';
const release = process.env.REACT_APP_SENTRY_RELEASE || process.env.REACT_APP_RENDER_GIT_COMMIT || undefined;

export function initSentry() {
  if (!dsn) return false;

  Sentry.init({
    dsn,
    environment,
    release,
    integrations: [
      Sentry.browserTracingIntegration(),
    ],
    tracesSampleRate: Number(process.env.REACT_APP_SENTRY_TRACES_SAMPLE_RATE || 0),
    replaysSessionSampleRate: 0,
    replaysOnErrorSampleRate: 0,
    sendDefaultPii: false,
  });

  return true;
}

export function captureFrontendException(error, context = {}) {
  if (!dsn) return;

  Sentry.withScope((scope) => {
    scope.setTag('service', 'vegai-frontend');
    Object.entries(context || {}).forEach(([key, value]) => {
      scope.setExtra(key, value);
    });
    Sentry.captureException(error);
  });
}

export function captureFrontendMessage(message, context = {}) {
  if (!dsn) return null;

  let eventId = null;
  Sentry.withScope((scope) => {
    scope.setTag('service', 'vegai-frontend');
    Object.entries(context || {}).forEach(([key, value]) => {
      scope.setExtra(key, value);
    });
    eventId = Sentry.captureMessage(message, 'info');
  });
  return eventId;
}
